import { attr, BaseModel } from "../../lib/itn-ui-kit/data";

export default class StaticBarModel extends BaseModel {
    @attr("json") medicalLimits;
    @attr("json") currentBalanceTotal;
    @attr("json") runningTotal;
    @attr("json") preferredLanguage;
    @attr("json") dateOfAccident;
    @attr("json") dateOfBirth;
    @attr("json") age;
    @attr("json") incidentCity;
    @attr("json") incidentState;
}
